function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { onEvent, onLoad } from '../../../../wdh-foundation/wdh';
require('../../../../wdh-foundation/wdh/src/js/polyfill/wdh-parentnode-prepend');

// region Country/Department filter
// Jira: OD-5003
(function () {
  var JobListFilter = /*#__PURE__*/function () {
    function JobListFilter(data, component) {
      var _this = this;
      _classCallCheck(this, JobListFilter);
      /**
       * @typedef {Object} JobListFilterDataCountry
       * @property {string} Name
       * @property {string[]} Departments
       */
      /**
       * @typedef {Object} JobListFilterDataLabels
       * @property {string} AllCountries
       * @property {string} AllDepartments
       */
      /**
       * @typedef {Object} JobListFilterData
       * @property {JobListFilterDataCountry[]} Countries
       * @property {JobListFilterDataLabels} Labels
       */

      /**
       * @type {JobListFilter}
       */
      this.data = data;
      this.component = component;
      this.componentContent = component.querySelector('.component-content');
      this.selectWrapper = document.createElement('div');
      this.selectWrapper.classList.add('select-wrapper');
      this.componentContent.prepend(this.selectWrapper);
      this.allCountriesCSSClass = 'all-countries';
      this.singleCountryCSSClass = 'single-country';
      this.countrySelectCSSClass = 'country-selected';
      this.departmentSelectCSSClass = 'departments';
      this.selectedCountry = this.data.Labels.AllCountries;
      this.selectedDepartment = this.data.Labels.AllDepartments;
      this.defaultCountry = this.data.DefaultCountry;
      this.setupSelectElements();
      this.setupEventHandling();
      this.initDefaults();
      setTimeout(function () {
        return _this.onSelectChange(_this.countrySelect);
      }, 0);
    }

    /**
     * Initializes the country select element if there is a default country set
     */
    return _createClass(JobListFilter, [{
      key: "initDefaults",
      value: function initDefaults() {
        var countries = this.data.Countries.map(function (country) {
          return country.Name;
        });
        if (!!this.defaultCountry && countries.indexOf(this.defaultCountry) !== -1) {
          this.countrySelect.value = this.defaultCountry;
        }
      }
    }, {
      key: "setupSelectElements",
      value: function setupSelectElements() {
        var _this2 = this;
        this.countrySelect = this.setupSelectElement(this.data.Labels.AllCountries, this.data.Countries);
        this.selectWrapper.appendChild(this.countrySelect);
        this.countrySelect.classList.add(this.countrySelectCSSClass);
        var departmentReducer = function departmentReducer(accumulator, currentValue) {
          return accumulator.concat(currentValue.Departments);
        };
        var departments = this.data.Countries.reduce(departmentReducer, []);
        this.departmentSelect = this.setupSelectElement(this.data.Labels.AllDepartments, departments);
        this.selectWrapper.appendChild(this.departmentSelect);
        this.departmentSelect.classList.add(this.countrySelectCSSClass);
        this.departmentSelect.classList.add(this.allCountriesCSSClass);
        this.departmentSelect.classList.add(this.departmentSelectCSSClass);
        this.countrySelects = {};
        this.data.Countries.forEach(function (country) {
          country.Name = escape(country.Name);
          var countryDepartmentSelect = _this2.setupSelectElement(_this2.data.Labels.AllDepartments, country.Departments);
          _this2.countrySelects[country.Name] = countryDepartmentSelect;
          _this2.selectWrapper.appendChild(countryDepartmentSelect);
          countryDepartmentSelect.classList.add(_this2.singleCountryCSSClass);
          countryDepartmentSelect.classList.add(country.Name);
          countryDepartmentSelect.classList.add(_this2.departmentSelectCSSClass);
        });
      }
    }, {
      key: "setupEventHandling",
      value: function setupEventHandling() {
        var _this3 = this;
        onEvent('custom-select-changed', function (changedSelect) {
          _this3.onSelectChange(changedSelect);
        });
      }

      /**
       * Creates and returns a new <select> element
       * @param {string} allEntriesLabel
       * @param {string[]|JobListFilterDataCountry[]} entries
       * @returns {HTMLSelectElement}
       */
    }, {
      key: "setupSelectElement",
      value: function setupSelectElement(allEntriesLabel, entries) {
        var _this4 = this;
        var select = document.createElement('select');
        select.appendChild(this.createOption(allEntriesLabel));
        entries = entries.filter(function (value) {
          return value !== null;
        }).map(function (entry) {
          return entry.Name || entry;
        });
        entries.sort(function (a, b) {
          return a.toLowerCase().localeCompare(b.toLowerCase());
        }).forEach(function (entry) {
          select.appendChild(_this4.createOption(entry.Name || entry));
        });
        select.value = allEntriesLabel;
        return select;
      }

      /**
       * Creates and returns a new <option> element
       * @param {strin] value
       * @returns {HTMLOptionElement}
       */
    }, {
      key: "createOption",
      value: function createOption(value) {
        var option = document.createElement('option');
        option.textContent = value;
        option.value = option.textContent;
        return option;
      }

      /**
       * Called when a select changes value. Determines what selects should be shown and
       * updates the <code>selectedCountry</code> and <code>selectedDepartment</code> properties.
       * Finishes by making a call to <code>updateJobEntries</code>.
       * @param {HTMLSelectElement} changedSelect
       */
    }, {
      key: "onSelectChange",
      value: function onSelectChange(changedSelect) {
        if (changedSelect === this.countrySelect) {
          this.removeClassFromSelect(".custom-select-wrapper.".concat(this.singleCountryCSSClass, ", .custom-select-wrapper.").concat(this.allCountriesCSSClass), this.countrySelectCSSClass);
          this.resetSelect(".custom-select-wrapper.".concat(this.singleCountryCSSClass, ", .custom-select-wrapper.").concat(this.allCountriesCSSClass), this.data.Labels.AllDepartments);
          this.selectedDepartment = this.data.Labels.AllDepartments;
          this.selectedCountry = this.countrySelect.value;
          if (this.selectedCountry === this.data.Labels.AllCountries) {
            this.addClassToSelect(".custom-select-wrapper.".concat(this.allCountriesCSSClass), this.countrySelectCSSClass);
          } else {
            this.addClassToSelect(".custom-select-wrapper.".concat(this.singleCountryCSSClass, ".").concat(this.selectedCountry), this.countrySelectCSSClass);
          }
        } else {
          this.selectedDepartment = changedSelect.value;
        }
        this.updateJobEntries();
      }

      /**
       * Removes a class from all matching elements found in component instance
       * @param {string} selector
       * @param {string} cssClass
       */
    }, {
      key: "removeClassFromSelect",
      value: function removeClassFromSelect(selector, cssClass) {
        this.component.querySelectorAll(selector).forEach(function (select) {
          select.classList.remove(cssClass);
        });
      }
    }, {
      key: "resetSelect",
      value: function resetSelect(selector, value) {
        this.component.querySelectorAll(selector).forEach(function (selectWrapper) {
          var select = selectWrapper.querySelector('select');
          select.value = value;
          var customSelect = selectWrapper.querySelector('.custom-select');
          var customSelectTrigger = customSelect.querySelector('.custom-select-trigger');
          customSelectTrigger.textContent = value;
          var selectedOption = customSelect.querySelector('.custom-option.selection');
          if (selectedOption) selectedOption.classList.remove('selection');
        });
      }
      /**
       * Adds a class to all matching elements found in component instance
       * @param {string} selector
       * @param {string} cssClass
       */
    }, {
      key: "addClassToSelect",
      value: function addClassToSelect(selector, cssClass) {
        this.component.querySelectorAll(selector).forEach(function (select) {
          select.classList.add(cssClass);
        });
      }
    }, {
      key: "updateJobEntries",
      value: function updateJobEntries() {
        var selector = 'li';
        if (this.selectedCountry !== this.data.Labels.AllCountries) {
          selector = "".concat(selector, "[data-country=\"").concat(this.selectedCountry, "\"]");
        }
        if (this.selectedDepartment !== this.data.Labels.AllDepartments) {
          selector = "".concat(selector, "[data-department=\"").concat(this.selectedDepartment, "\"]");
        }
        this.component.querySelectorAll('li').forEach(function (item) {
          item.style.display = 'none';
        });
        this.component.querySelectorAll(selector).forEach(function (item) {
          item.style.display = 'block';
        });
      }
    }]);
  }();
  var jobListFilters = [];
  onLoad(function () {
    var jobLinks = document.querySelectorAll('li > a.link');
    var jobHeaders = document.querySelectorAll('li > h3.job-header');
    jobHeaders.forEach(function (item, index) {
      var parent = item.parentElement;
      var link = jobLinks[index];
      parent.insertBefore(link, item);
      link.innerHTML = '';
      link.appendChild(item);
    });
    var components = document.querySelectorAll('.component.job-list-spot');
    components.forEach(function (component) {
      var dataConfiguration = component.getAttribute('data-configuration');
      if (dataConfiguration) {
        var configurationScript = document.querySelector("script[data-configuration='".concat(dataConfiguration, "']"));
        var configuration = configurationScript ? JSON.parse(configurationScript.textContent) : null;
        if (configuration) {
          jobListFilters.push(new JobListFilter(configuration, component));
        }
      }
    });
    $('select').each(function () {
      var classes = $(this).attr('class');
      var startUpText = $(this).attr('placeholder') || $(this).val();
      var template = "<div class=\"custom-select ".concat(classes, "\">");
      template += "<span class=\"custom-select-trigger\">".concat(startUpText, "</span>");
      template += '<div class="custom-options">';
      $(this).find('option').each(function () {
        template += "<span class=\"custom-option ".concat($(this).attr('class'), "\" data-value=\"").concat($(this).attr('value'), "\">").concat($(this).html(), "</span>");
      });
      template += '</div></div>';
      $(this).wrap("<div class=\"custom-select-wrapper ".concat(classes, "\"></div>"));
      $(this).hide();
      $(this).after(template);
    });
    $('.custom-option:first-of-type').hover(function () {
      $(this).parents('.custom-options').addClass('option-hover');
    }, function () {
      $(this).parents('.custom-options').removeClass('option-hover');
    });
    $('.custom-select-trigger').on('click', function (event) {
      $('html').on('click', function () {
        $('.custom-select').removeClass('opened');
      });
      $(this).parents('.custom-select').toggleClass('opened');
      event.stopPropagation();
    });
    $('.custom-option').on('click', function () {
      var $select = $(this).parents('.custom-select-wrapper').find('select');
      $select.val($(this).data('value'));
      $(this).parents('.custom-options').find('.custom-option').removeClass('selection');
      $(this).addClass('selection');
      $(this).parents('.custom-select').removeClass('opened');
      $(this).parents('.custom-select').find('.custom-select-trigger').text($(this).text());
      window.DGS.Event.getInstance().trigger('custom-select-changed', $select[0]);
    });
  });
})();
// endregion Country/Department filter